import React, { useEffect } from "react";
import Chart from "react-apexcharts";
import { useCurrencyStore } from "../../store/currencyStore";

const CurrenciesBarChart: React.FC = () => {
  const { currencies, fetchCurrencies } = useCurrencyStore();

  useEffect(() => {
    if (currencies.length === 0) {
      fetchCurrencies();
    }
  }, [currencies.length, fetchCurrencies]);

  const options: ApexCharts.ApexOptions = {
    chart: { type: "bar", height: 350, toolbar: { show: false } },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        borderRadius: 5,
        borderRadiusApplication: "end",
      },
    },
    dataLabels: { enabled: false },
    stroke: { show: true, width: 2, colors: ["transparent"] },
    xaxis: {
      categories: currencies.map((c) => c.currency),
      labels: { style: { colors: "#fff" } },
    },
    yaxis: {
      title: { text: "Exchange Rate" },
      labels: { style: { colors: "#fff" } },
    },
    fill: { opacity: 1 },
    tooltip: {
      y: { formatter: (val: number) => `MWK ${val.toLocaleString()}` },
    },
  };

  const series = [
    {
      name: "Rate",
      data: currencies.map((c) => c.rate), // rates as values
    },
  ];

  return (
    <div className="bg-card p-4 rounded-lg shadow my-4">
      <div className="flex items-center justify-between">
        <h2 className="text-md text-white font-semibold mb-4">
          Currency Rates Overview
        </h2>
        <h2 className="text-md text-white font-semibold mb-4">
          {new Date().getFullYear()}
        </h2>
      </div>

      <div className="flex items-center justify-between">
        <p className="text-sm text-white mb-2">
          Total Currencies: {currencies.length}
        </p>
      </div>

      <Chart options={options} series={series} type="bar" height={350} />
    </div>
  );
};

export default CurrenciesBarChart;
